<form-validation-collab
  *ngIf="showFormCollabContent"
  [utilisateurToValidate]="utilisateurToValidate"
  [crpcen]="crpcen"
  [codeValidation]="codeValidation"
>
</form-validation-collab>
<form-reset-collab
  *ngIf="!showFormCollabContent"
  [codeValidation]="codeValidation"
  [codeValidationAlreadyValidated]="codeValidationAlreadyValidated"
></form-reset-collab>
